<template>
	<div id="learn" v-if="loaded">
		<div class='chapter-list show' style="padding:0 3vw 8vw 3vw;">
		  <div style="display:flex;width:100%;">
		    <div style="flex:1" v-if="learnData.lists1.length > 0">
		      <div class='top zhangjie ' v-on:click="goFee(item)" v-for="item in learnData.lists1" style="border-radius:5px;font-weight:bold;width:41vw;height:10vw;margin:0px 3vw;background-color:#fbe5d8;margin-bottom:7vw;box-shadow:0px 3px 3px #9C9C9C;color:#14133b;display:inline-block">
			<div class="icon-order" style="height:10vw;width:10vw;line-height:10vw;color:#ed1400;display:inline-block;background-color:#d3e8f9;border-radius:5px 0px 0px 5px;margin-right:10px;border-right:3px solid #147ca1;font-size:16px;">{{item.tip}}</div>
			<span style="font-size:15px;">{{item.subject}}</span>
		      </div>
		    </div>
		    <div style="flex:1" v-if="learnData.lists2.length > 0">
		      <div class='top zhangjie ' v-on:click="goFee(item)" v-for="item in learnData.lists2" style="border-radius:5px;font-weight:bold;width:41vw;height:10vw;margin:0px 3vw;background-color:#fbe5d8;margin-bottom:7vw;box-shadow:0px 3px 3px #9C9C9C;color:#14133b;display:inline-block">
			<div class="icon-order" style="height:10vw;width:10vw;line-height:10vw;color:#FFFFFF;display:inline-block;background-color:#d3e8f9;border-radius:5px 0px 0px 5px;margin-right:10px;border-right:3px solid #147ca1;font-size:16px;">{{item.tip}}</div>
			<span style="font-size:15px;">{{item.subject}}</span>
		      </div>
		    </div>
		  </div>
		  <div style="display:block;border-top:1px solid #9D9D9D;width:100%;margin-top:0px;color:red;font-size:12px;line-height:18px;padding-top:10px;" v-if="cartype != 'D/E/F'">
		    <div>温馨提示：</div>
		    <div>1.学员一点通一千多道题库已同步更新。学会左边的红色必学题，每套题能达到95分以上即可模拟考试；</div>
		    <div>2.模拟考试能连续5次以上达到95分左右，即可参加考试；</div>
		    <div>3.如果模拟考试达不到要求，请把右边的选学题也学习一遍。</div>
		  </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Learn',
	data () {
		return {
			loaded:false,
			learnData:{
				lists1:[],
				lists2:[]
			},
			cartype:this.$route.query.cartype,
			qcolumn:this.$route.query.qcolumn
		}
	},
	created (){
		this.$https.post('/api/learn/lists',this.$qs.stringify({
			token:this.$store.state.token,
			cartype:this.cartype,
			qcolumn:this.qcolumn
		})).then((res) => {
			this.learnData = res.data.data
			this.loaded = true
		},(res) => {
			console.log(res)
		})
	},
	methods:{
		goFee(item){
			if (this.$store.state.userInfo.user_level_id || this.$store.state.config.data.updateing == '1' || 1) {
				this.$router.push({path: '/fee', query: {
					qcolumn:this.qcolumn,
					cartype:this.cartype,
					learn:item.id,
					subject_type:'learn'
				}});
			} else {
				console.log('去充值')
				//转向到充值
			}
		}
	}
}
</script>
<style scoped>
#learn{
	background-color:#FFFFFF;
	min-height:100vh;
	margin-bottom:50px;
}
.chapter-list.show{
  display:block;
}
.chapter-list.hide{
  display:none;
}
.chapter-list{
  display: flex;
  flex-flow: row wrap;
  padding: 0 10px 30px 10px;
}
.chapter-list > div{
  width: 50%;
  display: flex;
  padding-top: 6vw;
  line-height:8vw;
}
.chapter-list > div .icon-order{
  width: 9vw;
  height: 9vw;
  border-radius: 100%;
  span-align: center;
  line-height: 9vw;
  color: #fff;
  font-size: 12px;
  margin-right: 8px;
  text-align:center;
}
.chapter-list > div span{
  font-size: 14px;
}
.chapter-list > div .num{
  color: #999;
  font-size: 14px;
  margin-left:3px;
}
.greenbg{
  background: #74e882;
}
.bluebg{
  background: #2cd5ff;
}
.redbg{
  background: #ff7387;
}
.yellowbg{
  background: #f8b551;
}
.purplebg{
  background: #cf86f5;
}
</style>


// WEBPACK FOOTER //
// src/components/Learn.vue